// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"d2edcba4","169":"a5f021f9","238":"02c886fe","247":"1701074d","346":"55c4d1de","640":"591a2d4d","762":"810fdd6d"}[chunkId] + ".chunk.css";
};